import { FormattedMessage } from 'react-intl';
import { isToday } from '@alltrails/data-formatting/dateTimeConverters';
import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';

type TrailReviewDateProps = {
  created: string;
  languageRegionCode?: LanguageRegionCode;
};

const TrailReviewDate = ({ created, languageRegionCode }: TrailReviewDateProps) => {
  const reviewDate = new Date(created);
  const yesterdayDate = new Date();
  yesterdayDate.setDate(new Date().getDate() - 1);
  const yesterdayStart = new Date(yesterdayDate.setHours(0, 0, 0, 0));

  if (reviewDate > yesterdayStart) {
    return isToday(created) ? <FormattedMessage defaultMessage="Today" /> : <FormattedMessage defaultMessage="Yesterday" />;
  }
  return reviewDate.toLocaleDateString(languageRegionCode || 'en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

export default TrailReviewDate;
